<script lang="ts" setup>
defineProps<{
  icon: string
}>()
</script>

<template>
  <div class="group flex gap-4">
    <div class="flex flex-col items-center justify-start">
      <div class="bg-primary-600 shrink-0 grow-0 rounded-full p-4 leading-none">
        <UIcon :name="icon" class="size-6 text-white" />
      </div>
      <div
        class="block w-0.5 grow bg-gray-200 group-last:hidden dark:bg-gray-700"
      />
    </div>
    <div class="flex flex-col gap-2 pb-16 pt-3">
      <h3 class="text-lg font-bold text-gray-700 dark:text-gray-300">
        <slot name="title" />
      </h3>
      <p class="text-gray-600 dark:text-gray-400">
        <slot name="description" />
      </p>
    </div>
  </div>
</template>
